import React from 'react';
import toast from 'react-hot-toast';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { loginSliceValue } from '../../redux/reducers/loginSlice';
import { IPatientRes } from './index.type';

const useDeleteNote = ({ patientId }: { patientId?: string }) => {
  const { userDetails } = useSelector(loginSliceValue);
  const [deleteNoteLoading, setDeleteNoteLoading] = React.useState(false);

  const deleteNote = async (noteId: string) => {
    setDeleteNoteLoading(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_URL}/rtm/note?patientId=${patientId}&id=${noteId}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + userDetails.token,
        },
      });

      if (response.data?.status === 'success') {
        toast.success('Note deleted successfully');
        return response.data;
      }

      toast.error('Failed to delete note. Please try again.');
      return { status: 'fail' };
    } catch (error: any) {
      toast.error(error?.msg || 'Failed to delete note. Please try again.');
      return { status: 'fail' };
    } finally {
      setDeleteNoteLoading(false);
    }
  };

  return {
    deleteNoteLoading,
    deleteNote,
  };
};

export default useDeleteNote; 